// Shared worker, API and presentation safety; never logs rejected content.
export const UNSAFE_MARKER = /(raw\s*(?:provider\s*)?(?:payload|html|prompt|response)|service[- _]?role\s+(?:key|token|secret|credential)|\bbearer\s+[A-Za-z0-9._~+/=-]{16,}\b|\b(?:access|refresh)[-_ ]?token\s*(?:is|=|:)\s*[A-Za-z0-9._~+/=-]{12,}\b|\b(?:api|secret|private)[-_ ]?(?:key|token|credential)\s*(?:is|=|:)\s*\S+|stack\s*trace|<\s*script\b|javascript\s*:)/i;
const SENSITIVE_OUTPUT_KEY = /^(?:raw(?:Payload|Html|Prompt|ProviderResponse)|provider(?:Response|Payload|RawResponse)|prompt(?:Text|Payload)|apiKey|secret(?:Key|Token)?|accessToken|refreshToken|authorization|bearerToken|serviceRole(?:Key|Token)|password|stackTrace)$/i;

export const MALFORMED_PROVIDER_MARKUP = /<\s*\/?\s*(?:(?:antml:)?(?:parameter|tool(?:_use|_calls?)?|function(?:_calls?)?)|buyerEmpathyContext|evidenceSummary|recommendedActions|implementationSummary|validationNextStep|proofPoints(?:ToConfirm)?|outputTitle|outputType|opportunityTitle|targetAsset|targetAudience|assetSummary|competitorContext|evidencePattern|currentAssetContext|recommendedAngle|expectedResult|nextStep|recommended_asset_(?:url|type|label)|asset_action|supporting_context_(?:role|url)|targetLocation|assetContext|buyerIntent|localIntent|FAQsToAnswer|claimsToSupport|proofPointsNeeded|pageOrSchemaNotes|recommendedPageUpdates|headingRecommendations|faqSchemaRecommendations|comparisonContext|sectionOutline|recommendedStructure|implementationBrief)(?=[\s/>]|$)/i;

function inspectOutputStructure(value, state = { seen: new Set(), nodes: 0 }, depth = 0) {
  if (typeof value === "string" && MALFORMED_PROVIDER_MARKUP.test(value)) return { status: "rejected", categories: ["malformed_provider_markup"] };
  if (value === null || value === undefined || typeof value !== "object") return { status: "passed", categories: [] };
  if (depth > 12 || state.nodes >= 256) return { status: "failed", categories: ["inspection_failed"] };
  if (state.seen.has(value)) return { status: "failed", categories: ["inspection_failed"] };
  state.seen.add(value);
  state.nodes += 1;
  const entries = Array.isArray(value) ? value.map((item) => ["", item]) : Object.entries(value);
  for (const [key, child] of entries) {
    if (key && SENSITIVE_OUTPUT_KEY.test(key)) {
      state.seen.delete(value);
      return { status: "rejected", categories: ["internal_payload_reference"] };
    }
    const nested = inspectOutputStructure(child, state, depth + 1);
    if (nested.status !== "passed") {
      state.seen.delete(value);
      return nested;
    }
  }
  state.seen.delete(value);
  return { status: "passed", categories: [] };
}

export function inspectCaiOutputSafety(value) {
  try {
    const structure = inspectOutputStructure(value);
    if (structure.status !== "passed") return structure;
    const serialized = typeof value === "string" ? value : JSON.stringify(value);
    if (typeof serialized !== "string") return { status: "failed", categories: ["inspection_failed"] };
    if (UNSAFE_MARKER.test(serialized)) {
      const category = /<\s*script\b|javascript\s*:/i.test(serialized) ? "unsafe_markup"
        : /(?:bearer\s+|access[-_ ]?token\s*(?:is|=|:)|(?:api|secret|private)[-_ ]?(?:key|token|credential)\s*(?:is|=|:)|service[- _]?role\s+(?:key|token|secret|credential))/i.test(serialized)
          ? "credential_like"
          : "internal_payload_reference";
      return { status: "rejected", categories: [category] };
    }
    return { status: "passed", categories: [] };
  } catch {
    return { status: "failed", categories: ["inspection_failed"] };
  }
}
